(function($) {

	if ($('.home').length) {
		var playing = false;
		var mouseDown = 0;
		// hero animations
		$('svg path').on('wipe',function(){
			if (!playing) {
				$('.hero__content').animate({opacity:0},600);
				$('.hero').addClass('playing');
				setTimeout(function(){
					$('.hero').append('<a href="#" class="bring-back">Click me to bring back text</a>').find('.bring-back').fadeIn();
					$('.bring-back').on('click',function(){
						$('.hero__content').animate({opacity:1},600);
						$('.hero').removeClass('playing').find('.bring-back').remove();
						playing = false;
					});
				}, 800);				
				playing = true;
			} else {
				$(this).css('opacity',0);
			}
		});

		$('svg path').on('mousedown',function(){
			$(this).trigger('wipe');
		});

		$('svg path').on('mouseenter',function(){
			if (mouseDown) {
				$(this).trigger('wipe');
			}
		});

		document.body.onmousedown = function() { 
		  ++mouseDown;
		}
		document.body.onmouseup = function() {
		  --mouseDown;
		}

		// define animation triggers
		var triggers = {
			circles:{
				action: function() {
					$('.circles__header__line').addClass('animate');
					$('.circles__body').delay(300).slideDown(300,function(){
						var delay = 0;
						$('.mini-service').each(function(){
							$(this).delay(delay).animate({
								opacity: 1,
								left: 0,
							},250);
							delay += 150;
						});
						$('.mini-services__header__selector').delay(450).animate({opacity:1},300,function(){
							$('.mini-services__body').eq(0).slideDown(400);
							$('.circles').animate({borderWidth: 0});							
							setTimeout(function(){ $('.mini-service').eq(0).trigger('mouseenter'); }, 200);
						});
					});
				},
				flag: false,
			}			
		};

		defineTriggerPoints()

		function defineTriggerPoints() {
			triggers.circles.triggerPoint = $('.circles').offset().top - ( $(window).outerHeight() / 4 )
		}

		function scrollHome() {
			var winMid = $(window).scrollTop() + ($(window).outerHeight() / 2);

			// re-define the animation trigger spots on scroll and resize
			defineTriggerPoints()

			for (var trigger in triggers) {	
				var triggerObj = triggers[trigger];
				// check if trigger flag is false
				if (!triggerObj.flag) {
					// check if winMid is past the trigger point and if so, trip the flag and fxn
					if (winMid > triggerObj.triggerPoint) {
						triggers[trigger].flag = true;
						triggerObj.action();
					}
				}
			}
		}

		$(window).on('scroll resize',function(){	
			scrollHome();
		});

		scrollHome();
	}

})( jQuery );  